module.exports = __webpack_public_path__ + "media/images/icons/twotone/left-circle-b7c08e0797d9031305643068b8a02c64.svg";